/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {authorizeDigitalWalletPayment} from '../api'

export const useMutationAuthorizeDigitalWalletPayment = createReactQueryMutationHook('authorizeDigitalWalletPayment', authorizeDigitalWalletPayment)
